import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FeatureFlagService } from '@api/services/feature-flags.service';
import { Maps } from '@design/models/ui-state.model';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
@Component({ standalone: false,
  selector: 'lib-map-change',
  templateUrl: './map-change.component.html',
  styleUrls: ['./map-change.component.scss'],

})
export class MapChangeComponent {
  mapEvent!: Event;
  subscriptions = new Subscription();
  isNearMapEnabled: boolean = false;
  
  constructor(public dialogRef: MatDialogRef<MapChangeComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
      private featureFlagService: FeatureFlagService,
      private translateService: TranslateService,
  ) { }

  selectedMapval!: Maps | null;
  options = [
    {
      value: 'none',
      label: '',
      isVisible: (data: any) => data.selectedMapval === 'none',
    },
    {
      value: 'NearMap',
      label: 'design.leftPanel.mapOption.nearMap',
      isVisible: (data: any) => data.localeId === 'en_US' && data.showNmapCoverage && this.isNearMapEnabled,
    },
    {
      value: 'GoogleSolar',
      label: 'design.leftPanel.mapOption.googleSolar',
      isVisible: (data: any) => data.showGSolarCoverage,
    },
    {
      value: 'GoogleMap',
      label: 'design.leftPanel.mapOption.gMap',
      isVisible: () => true,
    },
    {
      value: 'CustomImage',
      label: 'design.leftPanel.mapOption.uImage',
      isVisible: () => true,
    },
  ];
  
  ngOnInit(): void {
    this.setFeatureFlags();
  }

  setFeatureFlags(){
    this.subscriptions.add(this.featureFlagService.isFeatureFlagsReady$.subscribe(isFlagsReady=>{
      if(!isFlagsReady){
        return;
      }

      this.isNearMapEnabled = this.featureFlagService.getFlag('near-map') ?? false ;
    }));
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    const data = { updateMap: true, event: this.mapEvent }
    this.dialogRef.close(data);
  }

  onCloseBtn(): void {
    this.dialogRef.close(false);
  }

  onMapChange(event: any) {
    this.mapEvent = event;
  }

  getSelectedOptionLabel(): string {
    const selectedOption = this.options.find(
      option => this.data.mapTypes[option.value] === this.data.selectedMapval
    );
    if (selectedOption && selectedOption.label) {
      return this.translateService.instant(selectedOption.label);
    }
    return this.data.selectedMapval || '';
  }
}
